import { Subject } from 'rxjs';

export enum UsePage {
    dashboard,
    tile,
}

export enum FocusSettingEventType {
    valueChange
}

export enum FocusSettinActionType {
    refreshFocus
}

export interface Focus {
    type: number;
    relationshipTypes?: Array<any>;
    entityId?: any;
    entityTypes?: Array<any>;
    enableFocusEntityType?: boolean;
    enableOneDegree?: boolean;
    entityRelationshipType?: boolean;
    enableCurrentUserRelationship?: boolean;
    enableFocusRelationType?: boolean;
    includeSpecificEntityItself?: boolean;
}

class Config {
    page: UsePage;
    focus: Focus;
    disabledEnabledFocusRelationship?: boolean;
    disabledAllFocus?: boolean;
    constructor() {
        this.page = UsePage.dashboard;
        this.focus = {
            type: 0
        };
    }
}

export class FocusSettingConfig {
    config: Config;
    events$: Subject<{ type: FocusSettingEventType, payload?: any }>;
    actions$: Subject<{ type: FocusSettinActionType, payload?: any }>;
    constructor() {
        this.config = new Config();
        this.events$ = new Subject();
        this.actions$ = new Subject();
    }
}
